import { css } from "@emotion/css";
import { useContext, useEffect, useState } from "react";
import { AppRoutes } from "./routes";
import { ENotificationKey } from "./utils/constants";
import pubsub from "sweet-pubsub";
import { initMixpanel, setUserAttributes } from "./libs";
import { UserContext } from "./context";
import { useSubscriptionPlan } from "./hooks";

function App() {
  const [show, setShow] = useState(false);
  const {state: userState} = useContext(UserContext)
  const { isFree, vipUser } = useSubscriptionPlan();

  useEffect(() => {
    if (import.meta.env.PROD) {
      initMixpanel();
    }
  }, []);

  useEffect(() => {
    if (import.meta.env.PROD && userState?._id) {
      setUserAttributes(userState._id, {
        email: userState.email || "",
        name: userState.firstName || "",
        plan: vipUser ? "VIP" : isFree ? "FREE" : "PRO",
      });
    }
  }, [userState?._id, userState?.email, userState?.firstName, vipUser, isFree]);

  useEffect(() => {
    const showCallback = (data: { value: boolean }) => {
      setShow(data.value);
    };
    pubsub.on(ENotificationKey.SHOW_DROPDOWN, showCallback);
    return () => {
      pubsub.off(ENotificationKey.SHOW_DROPDOWN, showCallback);
    };
  }, []);

  return (
    <>
      {show && (
        <div
          className={css`
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            backdrop-filter: blur(2px);
            background-color: rgba(0, 0, 0, 0.3);
            inset: 0;
            z-index: 999;
          `}
        />
      )}
      <AppRoutes />
    </>
  );
}

export default App;
